// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-2da7b0c6]:root{--navbar-width: 256px}.loading-mini-container[data-v-2da7b0c6]{background-color:rgba(255,255,255,0.95);position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;opacity:0;pointer-events:none;z-index:150;transition-property:opacity}.loading-mini-container.show[data-v-2da7b0c6]{opacity:1;pointer-events:auto}\n", ""]);
// Exports
module.exports = exports;
